export default __webpack_public_path__ + "static/media/success.e11e66ab.svg";